PJQ.views.commitments.ChangeOrderDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No Change Orders have been created yet',
            zeroRecords: "No Change Orders matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'data-table-header-change-orders')
        },
        toggleRowClass: '.change-order-toggle-row'
    },
    events: {
        'click .view-commitment': 'viewCommitmentClicked'
    },
    beforeDataTableRender: function () {
        this.options.pageLength = this.options.settings ? this.options.settings.rowsPerPage : 10;
    },
    getDefaultFilter: function () {
        return _.size(this.options.statusIds) > 0 ? this.options.statusIds : this.options.userSettings.get('defaultStatusFilter');
    },
    afterSearch: function () {
        if (typeof this.options.afterSearch === 'function') {
            this.options.afterSearch();
        }
    },
    afterHeaderRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('.change-orders-status-filter'),
            defaultValue: this.getDefaultFilter(),
            isIntChoices: true,
            isMultiple: true,
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {
                this.setFilter(PJQ.constants.commitments.changeOrderFilterType.STATUS_FILTER, value);
            }, this)
        });
        this.setFilter(PJQ.constants.commitments.changeOrderFilterType.STATUS_FILTER, this.getDefaultFilter());
    },
    getFilterData: function () {
        let statusFilter = this.getFilter(PJQ.constants.commitments.changeOrderFilterType.STATUS_FILTER);
        if (_.size(statusFilter) === 0) {
            return this.options.data;
        }

        return _.filter(this.options.data, function (row) {
            return (_.size(statusFilter) === 0 || _.contains(statusFilter, row.get('statusId')));
        });
    },
    getColumns: function (includeAllColumns = false) {
        this.options.canViewCommitments = PJQ.app.session.project.hasPermission('commitments.canView');

        let columns = [],
            includeColumns = ['status', 'commitment', 'contractedContact.companyName', 'number', 'changeReason', 'description', 'contractDate', 'invoicedDate', 'dueDate', 'createdOn', 'amount', 'markupAmount', 'taxAmount', 'grandTotal'];

        if (this.options.customFields) {
            _.each(this.options.customFields.models, _.bind(function (customField) {
                includeColumns.push('fieldValue' + customField.get('fieldNumber'));
            }, this));
        }

        if (!includeAllColumns) {
            if (this.options.settings && _.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings && this.options.settings.columnsDefault ? this.options.settings.columnsDefault : includeColumns;

            columns.push({
                "columnData": "childData",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": (data, type, row) => {
                    if (!this.options.isAdmin) {
                        return "";
                    }

                    let exObj = row.get('externalObject');
                    if (exObj == null) {
                        return '';
                    }

                    return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "data": "attributes.statusId",
                        "title": "Status",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.commitments.changeOrderStatusNames[row.get('statusId')]
                        }, this)
                    });
                    break;
                case 'commitment':
                    columns.push({
                        "columnData": "commitment",
                        "title": "Commitment",
                        "data": "attributes.commitmentNumber",
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return row.get('commitmentNumber');
                            }

                            if (this.options.canViewCommitments) {
                                return '<a class="view-commitment" href="javascript:void(0)" data-id="' + row.get('commitmentId') + '">' + row.get('commitmentNumber') + '</a>';
                            }
                            return data;
                        }, this)
                    },);
                    break;
                case 'number':
                    columns.push({
                        "columnData": "number",
                        "data": "attributes.number",
                        "title": "Number",
                        "render": _.bind(function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return row.get('number');
                            }

                            return '<a class="btn-view-change-order" href="javascript:void(0)" data-id="' + row.get('number') + '">' + row.get('number') + '</a>';
                        }, this)
                    });
                    break;
                case 'changeReason':
                    columns.push({
                        "columnData": "changeReason",
                        "data": "attributes.changeReason",
                        "title": "Change Reason"
                    });
                    break;
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description"
                    });
                    break;
                case 'contractDate':
                    columns.push({
                        "columnData": "contractDate",
                        "data": "attributes.contractDate",
                        "title": 'Contract Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'invoicedDate':
                    columns.push({
                        "columnData": "invoicedDate",
                        "data": "attributes.invoicedDate",
                        "title": 'Invoiced Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'dueDate':
                    columns.push({
                        "columnData": "dueDate",
                        "data": "attributes.dueDate",
                        "title": 'Due Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'createdOn':
                    columns.push({
                        "columnData": "createdOn",
                        "data": "attributes.createdOn",
                        "title": 'Created',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'contractedContact.companyName':
                    columns.push({
                        "columnData": "contractedContact.companyName",
                        "title": "Company",
                        "titleSettings": "Contracted Company",
                        "render": _.bind(function (data, type, row) {
                            return row.get('contractedContact') ? row.get('contractedContact').companyName : 'N/A';
                        }, this)
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "width": "10%",
                        "title": "Amount",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                        }, this)
                    });
                    break;
                case 'taxAmount':
                    columns.push({
                        "columnData": "taxAmount",
                        "data": "attributes.taxAmount",
                        "title": "Tax",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'markupAmount':
                    columns.push({
                        "columnData": "markupAmount",
                        "data": "attributes.markupAmount",
                        "title": "Markup",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'grandTotal':
                    columns.push({
                        "columnData": "grandTotal",
                        "data": "attributes.amount",
                        "title": "Grand Total",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                        }, this)
                    });
                    break;
                default:
                    if (columnName.startsWith('fieldValue')) {
                        _.each(this.options.customFields.models, function (customField) {
                            if (columnName === 'fieldValue' + customField.get('fieldNumber')) {
                                columns.push({
                                    "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                    "title": customField.get('name'),
                                    "render": function (data, type, row) {
                                        let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                        fieldValue = (fieldValue !== null) ? fieldValue : '';
                                        switch (customField.get('fieldTypeId')) {
                                            case PJQ.constants.commitments.customFieldType.BOOLEAN:
                                                if (fieldValue != null)
                                                    fieldValue = fieldValue ? 'Yes' : 'No';
                                                break;
                                            case PJQ.constants.commitments.customFieldType.CHOICE:
                                                let choices = [];
                                                // convert single choice value into array so that the logic below can work for both types.
                                                if (typeof fieldValue === 'number')
                                                    fieldValue = [fieldValue];

                                                _.each(customField.choices.models, _.bind(function (choice) {
                                                    if (_.find(fieldValue, function (value) {
                                                        return value === choice.get('id');
                                                    }))
                                                        choices.push(choice.get('name'));
                                                }, this));

                                                fieldValue = choices.join((', '));
                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATE:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATETIME:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.INTEGER:
                                                if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                    fieldValue = parseInt(fieldValue).toLocaleString();
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.MONEY:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.PERCENT:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true)).toFixed(2);
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = fieldValue ? fieldValue.toString() + '%' : '';
                                                }

                                                break;
                                        }

                                        return fieldValue;
                                    }
                                });
                            }
                        });
                    }
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-change-order ml-1" title="View change order"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "90px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    viewCommitmentClicked: function (e) {
        let row = this.getRow((e.currentTarget).closest('tr'));
        this.viewCommitment(row.data().get('commitmentId'));
    },
    viewCommitment: function (commitmentId) {
        new PJQ.views.commitments.CommitmentEditModal({
            model: new PJQ.models.commitments.Commitment({
                id: commitmentId
            })
        });
    }
});